<template>
  <div>
    <div class="tw-font-medium">Choose Profile Image</div>
    <div class="tw-flex tw-justify-center tw-mt-10">

      <div class="tw-flex tw-flex-col tw-max-w-full tw-gap-3" v-if="cropping">
        <cropper
          :src="fileUrl"
          :stencil-props="stencilProps"
          @new-props="updateCoordinates"
          ref="cropper"
          class="w-full"
        />

        <div class="tw-flex tw-justify-end">
          <button class="btn btn-primary btn-rounded" @click="cropAndSave">
            <span v-if="saving">Please Wait...</span>
            <span v-else>Save</span>
          </button>
        </div>
      </div>

      <div class="tw-relative tw-w-72" v-else>

        <img v-if="user || filePreviewUrl"
             :src="filePreviewUrl || user.avatar_url"
             class="tw-rounded-full tw-w-72 tw-h-72 tw-mr-4 tw-bg-gray-300"
             alt="profile avatar"/>

        <div v-else class="tw-rounded-full fas fa-circle-user tw-text-gray-300 tw-w-72 tw-h-72 tw-text-[270px]"></div>

        <button type="button"
                :disabled="cropping || saving"
                @click.prevent.stop="selectFile"
                class="tw-bottom-0 tw-right-0 tw-text-white hover:tw-text-white tw-border-solid tw-border-4 tw-border-white tw-absolute tw-bg-gray-300 tw-p-6 tw-rounded-full">
          <span class="fas fa-camera fa-2x"></span>
        </button>

        <div v-if="saving" class="tw-absolute tw-top-0 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center">
          <div class="tw-rounded-full tw-p-3 tw-bg-gray-300">
            Uploading...
          </div>
        </div>
      </div>
    </div>

    <div class="tw-font-medium tw-text-gray-400 tw-text-center tw-py-8">Minimum size 100x100</div>

    <b-form-file accept="image/*"
                 type="file"
                 class="d-none"
                 ref="fileInput"
                 v-model="file"
                 @input="onFileChange"/>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";
import {UsersApi} from "../../Api/UsersApi.js";
import {Cropper} from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

export default {
  components: {
    Cropper
  },
  mixins: [GeneralMixins],

  data() {
    return {
      cropping: false,
      file: null,
      fileUrl: null,
      filePreviewUrl: null,
      saving: false,
      user: null,
      coordinates: null,
      stencilProps: {
        aspectRatio: 1,
        movable: true,
        scalable: true,
        resizable: true,
      },
    }
  },

  mounted() {
    UsersApi.getCurrentUser().then(user => {
      this.user = user;
      console.log(this.user.avatar_url);
    }).catch(error => {
      this.showErrorToast(this.getErrorMessages(error, true))
    })
  },

  methods: {
    selectFile() {
      this.$refs.fileInput.$el.childNodes[0].click()
    },

    updateCoordinates(newCoordinates) {
      this.coordinates = newCoordinates;
    },

    onFileChange(e) {
      // this.selectedFile = e.target.files[0];
      // Create a URL to represent the file
      this.fileUrl = URL.createObjectURL(this.file);
      this.cropping = true
    },

    async cropAndSave() {
      this.saving = true;

      let resizedFile;

      try {
        const {canvas} = this.$refs.cropper.getResult();
        const file = await new Promise(resolve => canvas.toBlob(resolve));
        resizedFile = await this.resizeBlob(file, 500)
        this.filePreviewUrl = URL.createObjectURL(resizedFile);
      } catch (e) {
        this.saving = false;
        this.showErrorToast(this.getErrorMessages(error, true))
      }

      if (!resizedFile) {
        this.saving = false;
        return;
      }

      this.cropping = false;

      try {
        this.user = await UsersApi.changeAvatar(resizedFile);
        this.saving = false;
        this.$emit("saved");
      } catch (e) {
        this.saving = false;
        this.showErrorToast(this.getErrorMessages(e, true))
      }
    },

    async resizeBlob(blob, maxWidth, quality = 1) {
      return new Promise((resolve) => {
        // Create a URL for the blob
        const url = URL.createObjectURL(blob);

        // Create an image and set its source to the blob URL
        const img = new Image();
        img.src = url;

        img.onload = () => {
          // Check if the image is already smaller than the maximum width
          if (img.width <= maxWidth) {
            // If smaller, resolve the original blob without resizing
            resolve(blob);
          } else {
            // Determine the scaling factor
            const scaleFactor = maxWidth / img.width;

            // Determine the new dimensions
            const newWidth = img.width * scaleFactor;
            const newHeight = img.height * scaleFactor;

            // Create a canvas and set its dimensions
            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            // Draw the image onto the canvas at the new dimensions
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            // Export the canvas to a Blob with the specified quality
            canvas.toBlob((resizedBlob) => {
              resolve(resizedBlob);
            }, 'image/jpeg', quality);

            // Revoke the URL to free up resources
            URL.revokeObjectURL(url);
          }
        };
      });
    }
  }
}
</script>

